/* ============================================================
   NAVBAR 2026 — COMPORTAMIENTO
   - Mega menús (desktop): abrir/cerrar, cambio instantáneo entre menús,
     overlay, Escape, altura igualada, animación de links.
   - Drawer (≤991px): se construye a partir de los mega menús.
   - Editor de temas: se reinicia al editar la sección y abre el mega
     menú correspondiente al seleccionar una "Tarjeta destacada".
   ============================================================ */
(function(){
  if(window.__nav26Boot)return;
  window.__nav26Boot=true;

  var api=null;
  function el(tag,cls,text){var e=document.createElement(tag);if(cls)e.className=cls;if(text!=null)e.textContent=text;return e;}

  function init(root){
    var bar=root.querySelector('.nav26-bar');
    var burger=root.querySelector('.nav26-hamburger');
    var btns=[].slice.call(root.querySelectorAll('.nav26-btn[data-menu]'));
    var panels={};
    [].forEach.call(root.querySelectorAll('.nav26-mega[data-menu]'),function(p){panels[p.getAttribute('data-menu')]=p;});
    var keys=Object.keys(panels);

    /* ───────── MEGA MENÚS ───────── */
    var overlay=el('div','nav26-overlay');
    root.appendChild(overlay);
    var active=null,lastBtn=null;

    function setBtns(k){
      btns.forEach(function(b){
        var on=b.getAttribute('data-menu')===k;
        b.classList.toggle('is-active',on);
        b.setAttribute('aria-expanded',on?'true':'false');
      });
    }
    function openMenu(k){
      var p=panels[k];
      if(!p)return;
      var switching=active!==null;
      keys.forEach(function(key){
        if(switching)panels[key].classList.add('is-instant');
        panels[key].classList.remove('is-open');
      });
      void p.offsetWidth; /* reinicia la animación de los links */
      p.classList.add('is-open');
      setBtns(k);
      bar.classList.add('menu-open');
      overlay.classList.add('is-visible');
      active=k;
    }
    function closeMenus(){
      keys.forEach(function(key){panels[key].classList.remove('is-open','is-instant');});
      setBtns(null);
      bar.classList.remove('menu-open');
      overlay.classList.remove('is-visible');
      active=null;
    }
    btns.forEach(function(b){
      b.addEventListener('click',function(){
        var k=b.getAttribute('data-menu');
        lastBtn=b;
        if(active===k)closeMenus();else openMenu(k);
      });
    });
    overlay.addEventListener('click',closeMenus);

    function syncHeights(){
      if(window.innerWidth<992||!keys.length)return;
      keys.forEach(function(k){panels[k].style.height='auto';});
      var max=keys.reduce(function(h,k){return Math.max(h,panels[k].offsetHeight);},0);
      keys.forEach(function(k){panels[k].style.height=max+'px';});
    }
    syncHeights();
    window.addEventListener('load',syncHeights);
    if(document.fonts&&document.fonts.ready)document.fonts.ready.then(syncHeights);

    /* ───────── DRAWER MOBILE ───────── */
    var drawer=null,closeBtn=null;
    var data=btns.map(function(b){
      var k=b.getAttribute('data-menu');
      var sections=[];
      if(panels[k]){
        [].forEach.call(panels[k].querySelectorAll('.nav26-mega-col'),function(col){
          var t=col.querySelector('.nav26-mega-col-title');
          var items=[].map.call(col.querySelectorAll('.nav26-mega-item'),function(a){
            return {href:a.getAttribute('href')||'#',text:a.textContent.trim(),target:a.getAttribute('target')};
          });
          if(items.length)sections.push({label:t?t.textContent.trim():'',items:items});
        });
      }
      return {key:k,title:b.textContent.trim(),sections:sections};
    }).filter(function(d){return d.sections.length;});

    function openDrawer(){}
    function closeDrawer(){}

    if(burger&&data.length){
      drawer=el('div','nav26-drawer');
      drawer.id='nav26-drawer';
      drawer.setAttribute('role','dialog');
      drawer.setAttribute('aria-modal','true');
      drawer.setAttribute('aria-label','Menú de navegación');

      var header=el('div','nav26-drawer-header');
      var logo=root.querySelector('.nav26-logo');
      header.appendChild(logo?logo.cloneNode(true):el('span'));
      closeBtn=el('button','nav26-drawer-close');
      closeBtn.type='button';
      closeBtn.setAttribute('aria-label','Cerrar menú');
      closeBtn.innerHTML='<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18"/></svg>';
      header.appendChild(closeBtn);

      var tabs=el('div','nav26-drawer-tabs');
      tabs.setAttribute('role','tablist');
      var content=el('div','nav26-drawer-content');
      content.setAttribute('role','tabpanel');
      content.id='nav26-drawer-panel';
      var tabBtns=data.map(function(d){
        var t=el('button','nav26-drawer-tab',d.title);
        t.type='button';
        t.setAttribute('role','tab');
        t.setAttribute('aria-controls','nav26-drawer-panel');
        t.addEventListener('click',function(){render(d.key);});
        tabs.appendChild(t);
        return t;
      });

      var footer=el('div','nav26-drawer-footer');
      [[root.querySelector('.nav26-login'),'nav26-drawer-login'],[root.querySelector('.nav26-cta'),'nav26-drawer-cta']].forEach(function(pair){
        if(!pair[0])return;
        var a=el('a',pair[1],pair[0].textContent.trim());
        a.href=pair[0].getAttribute('href')||'#';
        if(pair[0].getAttribute('target'))a.target=pair[0].getAttribute('target');
        footer.appendChild(a);
      });

      drawer.appendChild(header);
      drawer.appendChild(tabs);
      drawer.appendChild(content);
      if(footer.children.length)drawer.appendChild(footer);
      root.appendChild(drawer);

      var render=function(key){
        var d=data.filter(function(x){return x.key===key;})[0]||data[0];
        content.innerHTML='';
        var i=0;
        d.sections.forEach(function(s){
          var sec=el('div','nav26-drawer-section');
          if(s.label)sec.appendChild(el('span','nav26-drawer-label',s.label));
          s.items.forEach(function(it){
            var a=el('a','nav26-drawer-item');
            a.href=it.href;
            if(it.target)a.target=it.target;
            var sp=el('span',null,it.text);
            sp.style.animationDelay=Math.min(i*0.045,0.4).toFixed(3)+'s';
            a.appendChild(sp);
            sec.appendChild(a);
            i++;
          });
          content.appendChild(sec);
        });
        content.scrollTop=0;
        tabBtns.forEach(function(t,idx){
          var on=data[idx].key===d.key;
          t.classList.toggle('is-active',on);
          t.setAttribute('aria-selected',on?'true':'false');
          t.tabIndex=on?0:-1;
        });
      };

      openDrawer=function(){
        render(data[0].key);
        drawer.classList.add('is-open');
        document.documentElement.classList.add('nav26-lock');
        burger.setAttribute('aria-expanded','true');
        setTimeout(function(){closeBtn.focus();},50);
      };
      closeDrawer=function(){
        if(!drawer.classList.contains('is-open'))return;
        drawer.classList.remove('is-open');
        document.documentElement.classList.remove('nav26-lock');
        burger.setAttribute('aria-expanded','false');
        burger.focus();
      };
      burger.addEventListener('click',openDrawer);
      closeBtn.addEventListener('click',closeDrawer);
    }

    return {
      openMenu:openMenu,
      closeMenus:closeMenus,
      /* Clic en cualquier parte fuera del panel abierto y de los botones → cerrar */
      outside:function(target){
        if(!active||!target||!target.closest)return;
        if(target.closest('.nav26-mega')||target.closest('.nav26-btn[data-menu]'))return;
        closeMenus();
      },
      escape:function(){
        if(drawer&&drawer.classList.contains('is-open')){closeDrawer();return;}
        if(active){closeMenus();if(lastBtn)lastBtn.focus();}
      },
      resize:function(){
        if(window.innerWidth<992){if(active)closeMenus();}
        else{closeDrawer();}
        syncHeights();
      }
    };
  }

  function boot(){
    document.documentElement.classList.remove('nav26-lock');
    var root=document.querySelector('[data-nav26]');
    if(!root||root.__nav26)return;
    root.__nav26=true;
    api=init(root);
  }

  document.addEventListener('keydown',function(e){if(e.key==='Escape'&&api)api.escape();});
  document.addEventListener('click',function(e){if(api)api.outside(e.target);});
  window.addEventListener('resize',function(){if(api)api.resize();});

  /* Editor de temas de Shopify */
  document.addEventListener('shopify:section:load',boot);
  document.addEventListener('shopify:block:select',function(e){
    if(!api||!e.target||!e.target.closest)return;
    var panel=e.target.closest('.nav26-mega');
    if(panel&&window.innerWidth>=992)api.openMenu(panel.getAttribute('data-menu'));
  });
  document.addEventListener('shopify:block:deselect',function(){if(api)api.closeMenus();});

  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',boot);else boot();
})();